import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { sharePreviewNative } from './sharePreview';
import { useOrder } from './useOrder';
import { Page } from './ui';

export default function PreviewPage() {
  const { slug = '' } = useParams();
  const { order, error, loading } = useOrder(slug);
  const [shareNote, setShareNote] = useState('');

  if (loading) return <Page><section className="cm-panel"><p className="cm-kicker">Carregando…</p></section></Page>;
  if (error || !order) return <Page><section className="cm-panel"><p className="cm-error">{error || 'Pedido não encontrado.'}</p></section></Page>;

  const previewUrl = typeof window !== 'undefined'
    ? `${window.location.origin}/criar-musica/previa/${order.slug}`
    : `https://www.inspiramusicas.com.br/criar-musica/previa/${order.slug}`;

  async function share() {
    setShareNote('');
    try {
      const result = await sharePreviewNative({
        title: `Prévia da música de ${order.recipientName}`,
        text: `Ouve 1 minuto da música de ${order.recipientName}:`,
        url: previewUrl,
        audioUrl: order.previewUrl,
      });
      if (result === 'copied') setShareNote('Link copiado. Cole no WhatsApp pra mandar.');
      if (result === 'whatsapp') setShareNote('Abrimos o WhatsApp pra você enviar.');
    } catch (err) {
      if ((err as DOMException)?.name === 'AbortError') return;
      setShareNote('Não deu pra compartilhar agora. Copie o link da página.');
    }
  }

  return (
    <Page>
    <section className="cm-panel">
      <p className="cm-kicker">1 minuto da música</p>
      <h1 className="cm-title">Ouça a prévia de {order.recipientName}</h1>
      <p className="cm-lead">Esse 1 minuto é um pedaço da música. Depois você escolhe o plano e finaliza o pedido.</p>
      {order.previewUrl ? (
        <audio className="cm-audio" controls src={order.previewUrl} />
      ) : (
        <p className="cm-note">A prévia ainda está sendo preparada.</p>
      )}
      <div className="cm-actions">
        <button type="button" className="cm-ghost" onClick={() => void share()}>
          Mandar no WhatsApp
        </button>
        <Link className="cm-cta" to={`/criar-musica/pedido/${order.slug}`}>Escolher o plano</Link>
      </div>
      {shareNote && <p className="cm-note">{shareNote}</p>}
      <p className="cm-note">Quem manda é você. A Inspira não dispara mensagem.</p>
    </section>
    </Page>
  );
}
